import { Box, Text } from "@chakra-ui/react";

import { Block } from "./MainBlocks/Block";

import CustomScroll from "react-custom-scroll";

export const Head04 = ({
  id,
  side,
  sentence,
  fam,
  size,
  height,
  spacing,
  weight,
  settings,
}) => {
  return (
    <Block id={id} sidebar={side}>
      <Box mb="16px">
        <CustomScroll>
          <Text
            width={{ base: "2000px", md: "100%", lg: "100%" }}
            maxHeight="500px"
            minH="100%"
            style={{ transition: "all .3s ease" }}
            fontFamily={fam}
            fontSize={size}
            lineHeight={`${height}px`}
            letterSpacing={`${spacing}px`}
            fontWeight={weight}
            // mb="16px"
          >
            {sentence}
          </Text>
        </CustomScroll>
      </Box>
      <hr style={{ width: "85%" }} />

      {/* Settings Block */}
      {settings}
    </Block>
  );
};
